<template>
	<div :style="'overflow-x: hidden;background:'+bgColor">
	<div class="syntheticRawMaterialsDetail-c product-c">
		<div >
			<!-- ../assets/images/hechengcailiao_banner.jpg -->
			<div style="width: 1920px;   height: 426px;overflow: hidden; margin-left: -357px;" class="banner-c"><img :src="bannerImage"></div>
		</div>
		<div class="bread-c">
			<div v-if="lang=='zh'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">首页</div>
				<div  style="cursor: pointer" @click="$router.push('/syntheticRawMaterials/'+lang)">> 特种氧化铝事业部</div> 
			</div>
			<div v-if="lang=='en'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">home page </div> 
				<div  style="cursor: pointer" @click="$router.push('/syntheticRawMaterials/'+lang)">> Special Alumina Division</div> 
			</div>
			<div v-if="lang=='ko'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">첫 페이지</div>
				<div  style="cursor: pointer" @click="$router.push('/syntheticRawMaterials/'+lang)">>  특수 산화 알루미늄 사업부</div>
			</div>
			<div v-if="lang=='ja'" style="display: flex;"><div @click="$router.push('/'+lang)" style="cursor: pointer;">最初のページ</div> 
				<div  style="cursor: pointer" @click="$router.push('/syntheticRawMaterials/'+lang)">> 特殊アルミナ事業部</div>
			</div>
		</div>
		<div class="f-l" :style="'background:'+leftBlockColor">
			<div class="l-content">
				<div class="head-c" style="padding: 9px 17px;margin-bottom: 8px;">
					<div style="margin-top: 10px;font-size: 18px;color: #0070B7;"  v-if="lang=='zh'">产品中心</div>
					<div style="margin-top: 10px;font-size: 18px;color: #0070B7;"  v-if="lang=='en'">Product Center</div>
					<div style="margin-top: 10px;font-size: 18px;color: #0070B7;"  v-if="lang=='ko'">プロダクトセンター</div>
					<div style="margin-top: 10px;font-size: 18px;color: #0070B7;"  v-if="lang=='ja'">제품 센터</div>
				
				</div>
				<!-- <ul>
					<li v-for="bussiness in businessList" @click="changeProduct(bussiness)">
						{{bussiness.productName}}
					</li>		
				</ul> -->
				<ul style="padding-bottom:300px">
					<li v-for="(bussiness,index) in categoryList" :key="index" @click="changeProduct(bussiness)">
						{{bussiness.label}}
						<div style="margin-left:20px" v-for="(item,index1) in bussiness.children" :key="index1" @click.stop="changeProduct(item)">
							{{item.label}}
							<div style="margin-left:20px" v-for="(item1,index2) in item.children" :key="index2" @click.stop="changeProduct(item1)">{{item1.label}}</div>
						</div>
					</li>
					<template v-if="indexConfig.xhlCategoryPositionObj">
						<img :src="xhlCategoryBgUrl" class="bg-img" :style="'width:'+indexConfig.xhlCategoryPositionObj.width+'px;height:'+indexConfig.xhlCategoryPositionObj.height+'px;left:'+indexConfig.xhlCategoryPositionObj.left+'px;bottom:'+indexConfig.xhlCategoryPositionObj.bottom+'px'">
					</template>
							
				</ul>
			</div>
		</div>
		<div class="f-r right-content" :style="'margin: 15px;background:'+leftBlockColor">
			<div class="image-c"><img :src="selectedContent.bannerUrl"></div>
			<div class="v-h">
				<div v-html="selectedContent.detail" style="line-height: 28px;padding: 0 11px;"></div>
			</div>
		</div>
		
		<div class="clearfix"></div>
		
	</div>
	<p-bottom :lang="lang"></p-bottom>
	</div>
</template>

<script>
	export default {
	  name: 'SyntheticRawMaterialsDetail',
	  props:{
		lang:{},
	
	  }, 
	  data() {
		return {
			  businessList:[],
			  currentLanguage:'zh',
			  currentSelected:null,
			  selectedContent:{},
			  categoryList:[],
			  bannerImage:'',
			  imageConfig:{},
			  indexConfig:{},
	  		  xhlCategoryBgUrl:'',
			  bgColor:'#fff',
			  leftBlockColor:'#fff',
			  rightBlockColor:'#fff',
		}
	  },
	  methods:{
		  async fetch(){		  
			  const res=await this.$http.get(`/syntheticMaterialProduct/${this.currentSelected}`);
			  this.selectedContent=res.data;	
			  	  
		  },
		  handelBg(){
			if(localStorage.getItem('backgroudColor')){
				this.bgColor = JSON.parse(localStorage.getItem('backgroudColor')).company2DetailColor
				this.leftBlockColor = JSON.parse(localStorage.getItem('backgroudColor')).company2Block1Color
				this.rightBlockColor = JSON.parse(localStorage.getItem('backgroudColor')).company2Block2Color
			}
			
		  },
		  async fetchIndex(){
			const res=await this.$http.post('/indexConfig',{la:this.currentLanguage})
			this.indexConfig = res.data||{}
			console.log('123',this.indexConfig.xhlCategoryBgUrl)
			this.xhlCategoryBgUrl = this.indexConfig.xhlCategoryBgUrl[0]['url']||''
		 },
		  async getImage(){
			const res=await this.$http.get('imageConfig')
			this.imageConfig = res.data[0]||{}
			this.bannerImage = this.imageConfig.secondTabBanner
		  },
		  async fethcList(){
			const listRes=await this.$http.get("syntheticMaterialList")
			listRes.data.map(function(data){
				if(data.language==this.lang){
					this.businessList.push(data)
				}
			}.bind(this))
			this.fechTreeData()
		  },
		  async fechTreeData(){
			  const res=await this.$http.get(`/categoryList`)
			  res.data.map(item =>{
				if(item.belong==='3'&&this.lang===item.language){
					this.categoryList = item.tree
				}
			  })
		  },
		  changeProduct(busniess){
			  const that = this
			  that.businessList.map(item =>{

				  if(item.productName === busniess.label){
					  that.currentSelected = item._id;
					  that.selectedContent=item
					  
					  that.$router.push("/syntheticRawMaterialsDetail/"+that.lang+'?id='+that.currentSelected)
				  }
			  })
			  //this.selectedContent=busniess;
			  
			  //localStorage.setItem('syntheicBusinessDetailData', JSON.stringify({id:busniess._id}))
			  //this.$router.push("/syntheticRawMaterials/"+this.lang+'?id='+busniess._id)
		  },
		  getLanguage(item){
			//   this.$router.push("/syntheticRawMaterialsDetail/"+this.lang+'?id='+this.currentSelected)
			console.log(item)
			if(!item.query.id){
				this.$router.push("/syntheticRawMaterials/"+this.lang)
			}	
			 
			  this.fetch()&&this.fethcList()
			  this.getImage()
			    
		  }
	
	  },
	  mounted(){
		  //this.currentSelected=JSON.parse(localStorage.getItem('syntheicBusinessDetailData')).id;
		  this.currentSelected=this.$route.query.id
		  this.currentLanguage=this.lang;
		  this.currentSelected&&this.fetch()&&this.fethcList()
		  this.fetchIndex()	
		  this.handelBg()	
		  this.getImage()
	  },
	  watch: {
	  		// 如果路由有变化，会再次执行该方法
	  		"$route": "getLanguage"
	  }
	}
</script>

<style>
	.syntheticRawMaterialsDetail-c{
		width: 1190px;
		margin: 0 auto;
	}
	.v-h img{
		width: 100%;
	}
	.syntheticRawMaterialsDetail-c .bread-c{
		line-height: 48px;
		border-bottom: 1px solid#f2f2f2;
		margin-bottom: 30px;
		color: #3155A5;
		font-size: 15px;
		padding-left: 10px;
		font-weight: 600;
	}
	.syntheticRawMaterialsDetail-c .l-content ul li{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
    .syntheticRawMaterialsDetail-c .f-l{
		position: relative;
	}
	.syntheticRawMaterialsDetail-c .f-l .l-content .bg-img{
		position: absolute;
		bottom: 0;
		width: 100%;
	}
	.syntheticRawMaterialsDetail-c .l-content ul li{
		width: 220px;
		height: auto;
		padding-left: 23px;
		font-size: 18px;
		color: #212121;
		font-weight: 600;
		line-height: 52px;
		cursor: pointer;
		position: relative;
		z-index: 1;
	}
	/* .syntheticRawMaterialsDetail-c .l-content ul li:hover{
		background: #feed01;
	} */
    .syntheticRawMaterialsDetail-c .right-content{
		width: 900px;
		-moz-box-shadow:0px 0px 0px #ccc, 1px 2px 4px #ccc;
		-webkit-box-shadow:0px 0px 0px #999999, 1px 2px 4px #999999;
		box-shadow:0px 0px 8px #ccc, 3px 2px 2px #ccc;
		padding: 15px;
		background: #fff;
		border: 1px solid#ccc;
	}
	.syntheticRawMaterialsDetail-c .right-content .image-c{
		width: 870px;
	}
	.syntheticRawMaterialsDetail-c .right-content .image-c img{
		width: 100%;
	}
	.syntheticRawMaterialsDetail-c .right-content .ql-align-center{
		text-align: center;
	}
</style>
